import { render, staticRenderFns } from "./BoInOutCash.vue?vue&type=template&id=197f6cf6&"
import script from "./BoInOutCash.vue?vue&type=script&lang=js&"
export * from "./BoInOutCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports